export const posthogProjectKey =
  "phc_EsNIhrP5PjuTQxFcmyr2PohaPoVFZnKAIbSdOQCW1vC";

// Server-side analytics uses PostHog's ingest host directly.
export const posthogHost = "https://us.i.posthog.com";
// Browser analytics goes through our managed reverse proxy.
export const posthogBrowserApiHost = "https://z.softmax.com";
// UI links should still point at the real PostHog app.
export const posthogUiHost = "https://us.posthog.com";
